import { render, staticRenderFns } from "./build8.vue?vue&type=template&id=230fa89d&scoped=true&"
import script from "./build8.vue?vue&type=script&lang=js&"
export * from "./build8.vue?vue&type=script&lang=js&"
import style0 from "./build8.vue?vue&type=style&index=0&id=230fa89d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230fa89d",
  null
  
)

export default component.exports